/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Discount_PercentInputs */

const vi_einvoice_draft_discount_percent = /** @type {(inputs: Einvoice_Draft_Discount_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu (%)`)
};

/**

* @param {Einvoice_Draft_Discount_PercentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_discount_percent = /** @type {((inputs?: Einvoice_Draft_Discount_PercentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Discount_PercentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_discount_percent(inputs)
});